import { supabase } from "@/integrations/supabase/client";
import { createServiceError } from "@/lib/apiErrors";

export interface MatchedTier {
  id: string;
  displayName: string;
  formLimit: number;
  retentionDays: number;
}

export interface JotformPlanSettingsResponse {
  success: boolean;
  accountType: string;
  status: string;
  planSlug: string;
  upgradeRequired: boolean;
  mismatchStartedAt: string | null;
  graceEndsAt: string | null;
  gracePeriodDays: number;
  enforcementActive: boolean;
  matchedTier: MatchedTier;
  error?: string;
}

export async function fetchJotformPlanSettings(): Promise<JotformPlanSettingsResponse> {
  const { data, error } = await supabase.functions.invoke("jotform-user-settings", {
    method: "POST",
    body: {},
  });

  if (error) {
    throw createServiceError(
      data?.error || error.message || "Failed to fetch Jotform settings",
      error
    );
  }

  if (!data?.success) {
    throw new Error(data?.error || "Failed to read Jotform account settings");
  }

  return data as JotformPlanSettingsResponse;
}
